import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { SelectArray } from 'hb-react/shared/components/formik/components/inputs';

export const Industries = () => {
  const { userFieldsConfig } = useJobContext();

  return (
    <SelectArray
      label={userFieldsConfig?.industries_label || s__('JobForm|Industries')}
      multiple
      name="industry_ids"
      placeholder={userFieldsConfig?.industries_placeholder}
      type="industries"
    />
  );
};
